export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname: 'div',
              name: "Coluns Numeros",
              attributes: { class: 'row-cubo' },
              components: [
                {
                  type: 'columnImageNumbers5',
                },
                {
                  type: 'columnNumbers5',
                },
      
              ],
              styles: `
             .row-cubo{
                display: flex; 
                flex-direction:row; 
                width:100%; 
             }
             @media (max-width:992px){
              .row-cubo{
                flex-direction:column;
              }
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};